import { render, staticRenderFns } from "./AuthorityToLeave.vue?vue&type=template&id=76911f19"
import script from "./AuthorityToLeave.vue?vue&type=script&lang=js"
export * from "./AuthorityToLeave.vue?vue&type=script&lang=js"
import style0 from "./AuthorityToLeave.vue?vue&type=style&index=0&id=76911f19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports